<!--
    @Author : Luo
    @Time   : 2020/7/15 9:24
-->
<template>
  <div class="page_header flex_center">
    <div class="page_header_text text_left">
      <span>数据处理中心</span>
    </div>
    <template v-if="accountVisible">
      <div class="logout">
        <div class="logout_container flex_center" @click="navMenuStatus">
          <div class="logout_label pointer_none"><span>{{ userName }}</span></div>
          <div class="logout_icon pointer_none">
            <svg-icon :className="'icon_down_style svg_icon_xs color_255 pointer_none'"
                      :iconClass="logoutStatus ? 'select_up' : 'select_down'"></svg-icon>
          </div>
        </div>
        <div v-show="logoutStatus" class="set_menu">
          <div class="set_menu_container" @click="setLogout">
            <span class="pointer_none">登出</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { _Ajax, initLogin, logout } from '@/api/_axios'

export default {
  name: 'page-header',
  data () {
    return {
      logoutStatus: false,
      userName: '',
      accountVisible: true // 查看账号信息的时候登出不可选
    }
  },
  methods: {
    setLogout: function () {
      let that = this
      that.logoutStatus = false
      logout(that.$router)
      // _Ajax(
      //   {
      //     method: 'get',
      //     url: '/api/logout'
      //   },
      //   (res) => {
      //     if (res.status === 401) {
      //       setTimeout(() => {
      //         that.$notice({type: 'error', content: '账号概览：认证令牌错误！'})
      //         logout(that.$router)
      //       }, 0)
      //     } else if (res.status === 200) {
      //       console.log(res)
      //     }
      //   },
      //   (rej) => { console.log('b--', rej) }
      // )
      // logout(this.$router)
    },
    getUser: function () {
      let that = this
      _Ajax(
        {
          method: 'get',
          url: '/api/profileManagement/home'
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '账号概览：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            that.userName = res.data.last_name + res.data.first_name
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    navMenuStatus: function (e) {
      e.stopPropagation()
      let that = this
      that.logoutStatus = !that.logoutStatus
    }
  },
  beforeMount: function () {
    let that = this
    initLogin(that.$router)

    let tempRoute = that.$route.query
    if (tempRoute.account && tempRoute.account === 'true') {
      that.accountVisible = false
    }
    that.getUser()
  },
  mounted: function () {
    let that = this
    let dom = document.querySelector('#app')
    dom.addEventListener('click', function () {
      if (that.logoutStatus) {
        that.logoutStatus = false
      } else {
        dom.removeEventListener('click', undefined, false)
      }
    }, false)
  }
}
</script>

<style scoped>
.logout {position: relative}
.page_header {height: 80px;background-color: rgba(46, 46, 46, 1);justify-content: space-between;padding-right: 28px}
.page_header_text {padding-left: 32px}
.page_header_text span {font-size: 24px;font-weight: 500;color: rgba(255, 255, 255, 1)}
.logout_container {cursor: pointer;padding-right: 8px}
.logout_label span {font-size: 16px;font-weight: 500;color: rgba(255, 255, 255, 1)}
.logout_icon {margin-left: 14px}

.set_menu {position: absolute;right: 0;top: 30px;background-color: rgba(255, 255, 255, 1);box-shadow: 0 2px 16px 0 rgba(144, 144, 144, .3);border-radius: 4px;overflow: hidden}
.set_menu_container {cursor: pointer;text-align: left;width: 108px;line-height: 40px;height: 40px;padding-left: 12px}
.set_menu_container span {font-size: 14px;font-weight: 400;color: rgba(96, 96, 96, 1)}
.set_menu_container:hover {background-color: rgba(61, 168, 245, 1)}
.set_menu_container:hover span {color: rgba(255, 255, 255, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-header/index.vue